export default {
	EM_ELABORACAO: { value: 'EM_ELABORACAO', text: 'Em Elaboração' },
	FINALIZADO: { value: 'FINALIZADO', text: 'Finalizado' },
}
